<template>
  <div>
    <div
      class="tag-box-list"
      :class="{ 'tag-box-list--rows': layoutRows === '1' }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "TagBoxList",
  props: {
    layoutRows: {
      type: String, // Boolean String; via twig as true but here its string 1
      default: "false",
    },
  },
};
</script>

<style lang="scss">
.tag-box-list {
  display: flex;
  flex-wrap: wrap;
  margin: -1vw 0 0 -1vw;

  &--rows {
    align-items: start;
    flex-direction: column;
  }

  .tag-box {
    margin: 1vw 0 0 1vw;
  }
}
</style>
